import {
  Box,
  Table as MuiTable,
  Paper,
  TableBody,
  TableContainer,
} from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import { usePagination } from 'src/hooks/usePagination';

import LoadingSpinner from '../LoadingSpinner';
import downloadExcelHandler from './Exports/downloadExcelHandler';
import StyledTableCell from './StyledTableCell';
import StyledTableRow from './StyledTableRow';
import TableHead from './TableHead';
import TableRowActions from './TableRowActions';
import TableToolbar from './TableToolbar';

const Table = (props) => {
  const {
    rows = [],
    headers,
    loading,
    rowActions = [],
    customPagination,
    tableActions = {},
    customTableActions,
    isToolBar = true,
    isPagination = true,
    color = 'primary',
    sortTable = null,
    setSelectedRows = null,
    selectedRows = null, fetching
  } = props;
  const defaultPagination = usePagination();

  const currentIndex =
    (defaultPagination.page + 1) * defaultPagination.rowsPerPage -
    defaultPagination.rowsPerPage;

  const tableRows = customPagination
    ? rows
    : (rows ?? []).slice(
      currentIndex,
      currentIndex + defaultPagination.rowsPerPage,
    );

  const downloadCurrentPageAsExcelDocumentButtonHandler = (data) => {
    downloadExcelHandler(data);
  };

  const defaultTableActions = {
    showDownloadCurrentPageAsExcelDocumentButton:
      tableActions.showDownloadCurrentPageAsExcelDocumentButton ?? true,
    downloadCurrentPageAsExcelDocumentButtonText:
      tableActions.downloadCurrentPageAsExcelDocumentButtonText ??
      'Excel (Página Actual)',
    downloadCurrentPageAsExcelDocumentButtonHandler: (
      tableActions.downloadCurrentPageAsExcelDocumentButtonHandler ??
      downloadCurrentPageAsExcelDocumentButtonHandler
    ).bind(null, tableRows),
    showDownloadAllPagesAsExcelDocumentButton:
      tableActions.showDownloadAllPagesAsExcelDocumentButton ?? false,
    downloadAllPagesAsExcelDocumentButtonText:
      tableActions.downloadAllPagesAsExcelDocumentButtonText,
    downloadAllPagesAsExcelDocumentButtonHandler:
      tableActions.downloadAllPagesAsExcelDocumentButtonHandler,
    loadingDownloadAllPagesAsExcelDocumentButton:
      tableActions.loadingDownloadAllPagesAsExcelDocumentButton ?? false,
  };

  return (
    <Box>
      {isToolBar ? (
        <TableToolbar
          selectedRows={selectedRows}
          fetching={fetching}
          tableActions={defaultTableActions}
          customTableActions={customTableActions}
        />
      ) : null}

      <TableContainer component={Paper}>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <MuiTable sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead
              selectedRows={selectedRows}
              rows={tableRows}
              setSelectedRows={setSelectedRows}
              color={color}
              sortTable={sortTable}
              headers={headers.concat((rowActions ?? []).length ? [{}] : [])}
            />
            <TableBody>
              {(tableRows ?? []).map((row, index) => (
                <StyledTableRow hover key={`table-row-${index}`}>
                  {headers.map((header, headerIndex) => (
                    <StyledTableCell
                      color={color}
                      key={`cell-${index}-${headerIndex}`}
                      {...(headerIndex === 0
                        ? {
                          component: 'th',
                          id: `enhanced-table-checkbox-${index}`,
                          scope: 'row',
                          align: 'center',
                        }
                        : { align: 'center' })}
                    >
                      {header.render ? header.render(row) : row[header.id]}
                    </StyledTableCell>
                  ))}

                  {rowActions.length > 0 && (
                    <StyledTableCell align="right" color={color}>
                      <TableRowActions row={row} actions={rowActions} />
                    </StyledTableCell>
                  )}
                </StyledTableRow>
              ))}
            </TableBody>
          </MuiTable>
        )}
      </TableContainer>
      {isPagination ? (
        <TablePagination
          rowsPerPageOptions={[10, 50, 100]}
          component="div"
          count={customPagination?.count ?? (rows ?? []).length}
          rowsPerPage={
            customPagination?.rowsPerPage ?? defaultPagination.rowsPerPage
          }
          page={customPagination?.page ?? defaultPagination.page}
          onPageChange={
            customPagination?.onPageChange ?? defaultPagination.handleChangePage
          }
          onRowsPerPageChange={
            customPagination?.onRowsPerPageChange ??
            defaultPagination.handleChangeRowsPerPage
          }
          showFirstButton={true}
          showLastButton={true}
        />
      ) : null}
    </Box>
  );
};

export default Table;
